<template>
  <v-container v-if="donorDetails" class="donor-details-component">
    <v-dialog
      v-model="dialogOpen"
      fullscreen
      transition="dialog-top-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="white"
        >
          <v-spacer />
          <v-btn
            dark
            @click="dialogOpen = false"
          >
            <v-icon class="close-button pl-1 pt-2" size="24" color="primary">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
    </v-dialog>
    <div class="photo-wrapper" @click="toggleFavourite">
      <img :src="placeholder" class="photo" />
    </div>

<!--
  <div class="id-wrapper d-flex flex-column text-left text-md-center flex-grow-1 ml-md-0 ml-4 justify-start">
    <div class="result_header mb-2">
      {{$t(`donor.${phenotypeData.material.type}.nom`)}}
    </div>
    <div class="d-flex justify-md-center justify-start align-center">
      <div class="id">
        {{ phenotypeData.donor_process.donor_nickname }}
      </div>
      <v-icon @click="toggleFavourite" :icon="isFavourite ? 'mdi-heart' : 'mdi-heart-outline'" :size="24" class="ml-md-1 ml-4" color="primary"></v-icon>
    </div>
  </div>
-->

    <div class="id-wrapper pt-0 text-left text-md-center">
      <div class="donor_label">{{$t(`donor.${donorDetails.material.type}.nom`)}}</div>
      <div class="id mt-1">
        {{ donorDetails.donor_process.donor_nickname }}
      </div>
        <v-icon @click="toggleFavourite" :icon="isFavourite ? 'mdi-heart' : 'mdi-heart-outline'" size="24" class="icon-photo" color="primary"></v-icon>
      <div class="d-flex flex-row justify-start justify-md-center compare_list_checkbox pt-2">
        <label class="container input-label text-left pr-2 mt-2 mb-6 mb-md-0">
          <div v-html="isInCompareList ? $t('compare_list.added_to_compare_label') : $t('compare_list.add_to_compare_label')"></div>
          <input type="checkbox"
            :checked="isInCompareList"
            @click="toggleCompareListItem($event)"
          >
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
    
    <div class="right-bar" v-if="$vuetify.display.mobile">
      <v-icon @click="open = true" v-if="$vuetify.display.mobile">mdi-dots-vertical</v-icon>
      <div
        class="menu-mobile"
        v-if="$vuetify.display.mobile && open"
        v-click-outside="close">
        <div class="menu-item pl-5 py-4" @click="copyLink">
          <v-icon class="icon">mdi-share-variant-outline</v-icon><div>{{$t('donor.details.share_btn')}}</div>
        </div>
        <div class="menu-item pl-5 py-4" @click="downloadDonorFile">
          <v-icon class="icon">{{downloading ? 'mdi-loading mdi-spin' : 'mdi-tray-arrow-down'}}</v-icon><div>{{$t('donor.details.download_btn')}}</div>
        </div>
      </div>
    </div>
    <div class="data-row pl-md-5 pl-0">
      <div class="main-header text-left mb-9 mt-md-0 mt-6">
        {{$t('donor.phenotype.header')}}
      </div>
      <div class="header d-flex flex-row">
          <img :src="eye_icon" class="mr-2"/>
          <span class="header_label flex-grow-1 text-left">{{$t('donor.phenotype.physical_features_label')}}</span>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.phenotype.eye_color')}}</div>
          <div class="data-value flex-grow-1 text-left text-capitalize">{{ $t('phenotype.eye_color.' + donorDetails.material.type + '.' + donorDetails.phenotype.eye_color) }}</div>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.phenotype.hair_color')}}</div>
          <div class="data-value flex-grow-1 text-left text-capitalize">
            {{$t('phenotype.hair_color.' + donorDetails.material.type + '.' + donorDetails.phenotype.hair_color).match(/([^\()]+)/)[0] }}<br/>
            <span class="sub-entry" v-if="$t('phenotype.hair_color.' + donorDetails.material.type + '.' + donorDetails.phenotype.hair_color).match(/\((.*?)\)/)">{{$t('phenotype.hair_color.' + donorDetails.material.type + '.' + donorDetails.phenotype.hair_color).match(/\((.*?)\)/)[0]}}</span> 
          </div>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.phenotype.hair_shape')}}</div>
          <div class="data-value flex-grow-1 text-left text-capitalize">{{ $t('phenotype.hair_structure.' + donorDetails.material.type + '.' + donorDetails.phenotype.hair_structure) }}</div>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.phenotype.height')}}</div>
          <div class="data-value flex-grow-1 text-left">{{ donorDetails.phenotype.height }} {{$t('cm')}}</div>
      </div>
      <!-- <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.phenotype.weight')}}</div>
          <div class="data-value flex-grow-1 text-left">{{ donorDetails.phenotype.weight }} {{$t('kg')}}</div>
      </div> -->
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.phenotype.body_type')}}</div>
          <div class="data-value flex-grow-1 text-left">
              {{$t('phenotype.silhouette.' + donorDetails.material.type + '.' + donorDetails.phenotype.silhouette).match(/([^\s]+)/)[0] }} <br>

              <span class="sub-entry">{{$t('phenotype.silhouette.' + donorDetails.material.type + '.' + donorDetails.phenotype.silhouette).match(/\((.*?)\)/)[0] }}</span> 
          </div>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.phenotype.age')}}</div>
          <div class="data-value flex-grow-1 text-left">{{ getAgeString() }}</div>
      </div>
      <!-- <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.phenotype.education')}}</div>
          <div class="data-value flex-grow-1 text-left text-capitalize">{{ $t('phenotype.education.' + donorDetails.material.type + '.' + donorDetails.phenotype.education) }}</div>
      </div> -->

      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.phenotype.skin_color')}}</div>
          <div class="data-value flex-grow-1 text-left">{{$t('phenotype.skin_color.' + donorDetails.material.type + '.' + donorDetails.phenotype.skin_color).match(/([^\s]+)/)[0] }}<br/>
            <span class="sub-entry" v-if="$t('phenotype.skin_color.' + donorDetails.material.type + '.' + donorDetails.phenotype.skin_color).match(/\((.*?)\)/)">{{$t('phenotype.skin_color.' + donorDetails.material.type + '.' + donorDetails.phenotype.skin_color).match(/\((.*?)\)/)[0]}}</span> 
          </div>
      </div>
      <v-divider class="my-6"></v-divider>
      <div class="header d-flex flex-row">
          <img :src="blood_icon" class="mr-2"/>
          <span class="header_label flex-grow-1 text-left">{{$t('donor.phenotype.blood_label')}}</span>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.phenotype.blood_type')}}</div>
          <div class="data-value flex-grow-1 text-left">{{ $t('phenotype.blood_type.' + donorDetails.material.type + '.' + donorDetails.phenotype.blood_type) }}</div>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.phenotype.blood_fh_factor')}}</div>
          <div class="data-value flex-grow-1 text-left">{{ $t('phenotype.blood_rh_factor.' + donorDetails.material.type + '.' + donorDetails.phenotype.blood_rh_factor) }}</div>
      </div>
      <v-divider class="my-6"></v-divider>
      <div class="header d-flex flex-row mt-6">
          <img :src="group_icon" class="mr-2"/>
          <span class="header_label flex-grow-1 text-left">{{$t('donor.phenotype.origin_label')}}</span>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.phenotype.race')}}</div>
          <div class="data-value flex-grow-1 text-left">
            {{$t('phenotype.race.' + donorDetails.material.type + '.' + donorDetails.phenotype.race).match(/([^\()]+)/)[0] }}<br/>
            <span class="sub-entry" v-if="$t('phenotype.race.' + donorDetails.material.type + '.' + donorDetails.phenotype.race).match(/\((.*?)\)/)">{{$t('phenotype.race.' + donorDetails.material.type + '.' + donorDetails.phenotype.race).match(/\((.*?)\)/)[0]}}</span> 
          </div>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.phenotype.ethnicity')}}</div>
          <div class="data-value flex-grow-1 text-left">{{getEthnicity}}</div>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.phenotype.secondary_ethnicity')}}</div>
          <div class="data-value flex-grow-1 text-left">{{getSecondaryEthnicities}}</div>
      </div>
      <div class="main-header text-left mb-9 mt-12">
        {{$t('donor.location_header')}}
      </div>
      <div class="data-wrapper d-flex flex-row mb-10 mb-md-0">
          <div class="data-label flex-grow-1 text-left">{{$t('donor.location_label')}}</div>
          <div class="data-value flex-grow-1 text-left">{{$t(donorDetails.material.location.city)}}</div>
      </div>
    </div>
  </v-container>
  <v-container v-else>
    <v-progress-circular
        indeterminate
        color="primary"
        :size="50"
        :width="5"
        class="mt-10"
    ></v-progress-circular>
  </v-container>
</template>

<script>
import { computed } from 'vue';
import { useStore, mapGetters } from 'vuex'
import axios from "axios";

export default {
  name: 'DonorDetailsComponent',
  props: {
    donorDetails: Object,
    materialType: String,
    publicDonorId: String,
    age: Number,
  },
  data() {
    return {
      open: false,
      alertOpen: false,
      dialogOpen: false,
      downloading: false,
      store: useStore()
    }
  },
  watch: {
    alertOpen(){
      if(this.alertOpen) {
        setTimeout(() => {
          this.alertOpen = false;
        }, 5000)
      }
    }
  },
  computed: {
    ...mapGetters('compareModule', ['getCompareList', 'getCompareListByMaterialType', 'getContext']),
    isInCompareList() {
      return this.getCompareListByMaterialType(this.materialType).find(e => e.pk == this.donorDetails.id);
    },
    getEthnicity() {
      const ethnicity = this.donorDetails.phenotype.ethnicity;
      return ethnicity ? this.$t(`phenotype.ethnicity.${this.donorDetails.material.type}.${ethnicity}`) : this.$t(`empty_value`);
    },
    getSecondaryEthnicities() {
      let secondaryEthnicities = '';
      const subethnicities = this.donorDetails.phenotype.subethnicities;
      for (let e in subethnicities) {
        secondaryEthnicities += (e > 0 ? ', ' : '') + this.$t(`phenotype.subethnicities.${this.donorDetails.material.type}.${subethnicities[e]}`);
      }
      return secondaryEthnicities ? secondaryEthnicities : this.$t(`empty_value`)
    },
    ...mapGetters('favouritesModule', ['getFavourites']),
    isFavourite() {
        return this.getFavourites.find(e => e.donor_product_key == this.donorDetails.id && e.material_type == this.materialType);
    },
    
  },
  setup(props) {
    const store = useStore();
    const placeholder = computed({
        get: () => {
            if(props.donorDetails.material.type == "mtCell")
                return require('../assets/img/placeholder_female.svg')
            else
                return require('../assets/img/placeholder_male.svg')
        }
    })
    const eye_icon = computed({
      get: () => { return require('../assets/icons/eye.svg');}
    })
    const blood_icon = computed({
      get: () => { return require('../assets/icons/blood.svg');}
    })
    const group_icon = computed({
      get: () => { return require('../assets/icons/group.svg');}
    })
    return {
        placeholder,
        eye_icon,
        blood_icon,
        group_icon,
        oidcUser: computed(() => store.getters['oidcStore/oidcUser']),
    }
  },
  methods: {
    getAgeString() {
      let end = this.age % 10;
      switch(end) {
        case 2:
        case 3:
        case 4: 
          return this.age + ` ${this.$t('lata')}`;
        default:
          return this.age + ` ${this.$t('lat')}`;
      }
    },
    close() {
      this.open = false;
    },
    copyLink() {
      const absoluteURL = new URL(this.$route.href, window.location.origin).href;
      navigator.clipboard.writeText(absoluteURL);
      this.alertOpen = true;
      this.close();
    },
    forceFileDownload(response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    downloadDonorFile() {
      this.downloading = true;
      const fit = this.donorDetails.material.fitness_for_insemination;
      this.$emit('downloading', true);
      axios
        .post(`/api/printout/donor/${this.donorDetails.id}/${this.materialType}`, {
          "donor_id": this.publicDonorId,
          "donor_nickname": this.donorDetails.donor_process.donor_nickname,
          "material_location": this.$t(this.donorDetails.material.location.city),
          "fitness_for_insemination": fit ? this.$t(fit) : '',
          "language": this.$i18n.locale,
          "phenotype_data": {
            "blood_type": `${this.$t('phenotype.blood_type.' + this.materialType + '.' + this.donorDetails.phenotype.blood_type)}`,
            "blood_rh_factor": `${this.$t('phenotype.blood_rh_factor.' + this.materialType + '.' + this.donorDetails.phenotype.blood_rh_factor)}`,
            "race": `${this.$t('phenotype.race.' + this.materialType + '.' + this.donorDetails.phenotype.race)}`,
            "skin_color": `${this.$t('phenotype.skin_color.' + this.materialType + '.' + this.donorDetails.phenotype.skin_color)}`,
            "eye_color": `${this.$t('phenotype.eye_color.' + this.materialType + '.' + this.donorDetails.phenotype.eye_color)}`,
            "hair_color": `${this.$t('phenotype.hair_color.' + this.materialType + '.' + this.donorDetails.phenotype.hair_color)}`,
            "hair_structure": `${this.$t('phenotype.hair_structure.' + this.materialType + '.' + this.donorDetails.phenotype.hair_structure)}`,
            "height": this.donorDetails.phenotype.height,
            "weight": this.donorDetails.phenotype.weight,
            "age": this.age,
            "silhouette": `${this.$t('phenotype.silhouette.' + this.materialType + '.' + this.donorDetails.phenotype.silhouette)}`,
            "ethnicity": this.getEthnicity,
            "secondary_ethnicity": this.getSecondaryEthnicities,
          }
        },
        {
          responseType: "blob",
        })
        .then((response) => {
          this.forceFileDownload(response, `${this.donorDetails.id}.pdf`)
        })
        .catch(err => {
          if (err.response) {
            console.error(err.response.data)
          }
        })
        .finally(() => {
          this.downloading = false
          this.$emit('downloading', false);
          this.close()
        });
    },
    toggleFavourite(){
      if(this.oidcUser) {
        if(this.isFavourite){
          this.store.dispatch('favouritesModule/removeFavourite', {
              donor_product_key: this.donorDetails.id,
              material_type: this.materialType
          })
        } else {
          this.store.dispatch('favouritesModule/addFavourite', {
              donor_product_key: this.donorDetails.id,
              material_type: this.materialType
          })
        }
      } else {
        this.dialogOpen = true;
      }
    },
    toggleCompareListItem(e){
      this.$store.dispatch(
        'compareModule/toggleCompareListItem',
        {
          id: this.donorDetails.donor_process.donor_nickname,
          pk: this.donorDetails.id,
          materialType: this.materialType})
      .then(result => {
        if(!result) {
          this.$root.$alertMessageRef.showAlert(
            this.$t(`alert.COMPARE_LIST_FULL.title`, {}),
            this.$t(`alert.COMPARE_LIST_FULL.message`, {}),
            {
              link: false,
              backgroundColor: 'rgb(254,245,228)',
              borderColor: 'rgb(255, 230, 100)',
              timeout: true,
              timeoutDuration: 5000,
              iconColor: 'rgba(249, 193, 0, 1)',
              icon: 'mdi-information-outline',
              width: 'auto'
            }
          )
          e.preventDefault();
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.donor-details-component {
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: auto 1fr;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
}

.photo-wrapper { grid-area: 1 / 1 / 2 / 2; }
.id-wrapper   { grid-area: 1 / 2 / 2 / 3; }
.right-bar   { grid-area: 1 / 3 / 2 / 4; }
.data-row   { grid-area: 2 / 1 / 3 / 4; }

.donor_label {
    color: var(--bank-primary, #00205B);
    @include nsb-gentium-bold;
    font-size: 23px;
    font-style: normal;
    // font-weight: 700;
    line-height: 145%; /* 33.35px */
}

.photo-wrapper {
  position: relative;
  background: white;
  padding: 0px;
  cursor: pointer;

  .icon-photo {
    display: block;
    width: 20px !important;
    height: 20px !important;
    // padding: 4px;
    position: absolute;
    top: 7px;
    right: 14px;
    cursor: pointer;
    color: $nsb-color-9;
  }

  .photo {
    width: 100%;
    width: 135px;
  }
}
.id-wrapper {
  .label {
    @include nsb-font-header;
    font-size: 14px;
    line-height: 21px;
    color: $ds-primary;
  }
  .id {
    @include nsb-font-container;
    font-size: 14px;
    line-height: 21px;
    color: $ds-primary;
    border-radius: 12px;
    background-color: $ds-primary-9;
    display: inline-block;
    padding: 1.5px 12px;
  }
}
.header {
  @include nsb-font-container-medium;
  font-size: 14px;
  line-height: 21px;
  color: $ds-primary;
}
.data-wrapper {
  @include nsb-font-container;
  font-size: 14px;
  line-height: 21px;
  margin: 8px auto;
  .data-label {
      width: 45%;
      color: $ds-primary-3;
  }
  .data-value {
      width: 55%;
      color: $ds-primary;
  }
}
.sub-entry {
  font-size: 10px;
  color: $ds-primary;
}
.main-header {
  @include nsb-font-main-header;
}
.menu-mobile {
  @include nsb-font-input;
  box-sizing: border-box;
  position: absolute;
  right: 40px;
  top: 160px;
  box-shadow: 0px 2px 3px rgba(0,0,0,0.3);
  background: white;
  width: 163px;
  display: flex;
  flex-direction: column;
  .menu-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    &:hover {
      background: rgba(0,0,0,0.1)
    }
    .icon {
      margin-right: 12px;
      font-size: 14px;
      padding-bottom: 2px;
    }
  }
}
@media (min-width: 960px) {
  .donor-details-component {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto 1fr;
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    padding: 0;
  }

  .photo-wrapper { grid-area: 1 / 1 / 2 / 2;}
  .id-wrapper { grid-area: 2 / 1 / 3 / 2;}
  .data-row { grid-area: 1 / 2 / 3 / 3;}

  .id-wrapper {
    max-width: 160px;
  }
}
.input-label {
    @include nsb-font-container;
      font-size: 14px;
      line-height: 17px;
      cursor: pointer;
      color: $ds-primary;
}

/* The container */
.container {
  display: block;
  position: relative;
  padding-left: 24px;
  cursor: pointer;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  box-sizing: border-box;
  border: 1px solid #869AB7;
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: white;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: $nsb-disabled;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: $ds-primary;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 5px;
  top: 2px;
  width: 4px;
  height: 9px;
  border: solid white;
  border-width: 0 1px 1px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>